import { MatFormFieldModule } from '@angular/material/form-field';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormlyModule } from '@ngx-formly/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { MatDatepickerModule } from '@angular/material/datepicker';

import { ExternalTypeComponent } from './external-type.component';
import { MatIconModule } from '@angular/material/icon';
import { DatepickerMaskDirective } from '@lockton-apps/shared/ui/lui';
import { DynamicModule } from 'ng-dynamic-component';

@NgModule({
  declarations: [ExternalTypeComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatInputModule,
    MatDatepickerModule,
    MatFormFieldModule,
    DatepickerMaskDirective,

    FormlyModule.forChild({
      types: [
        {
          name: 'external',
          component: ExternalTypeComponent,
          wrappers: ['addons'],
        },
      ],
    }),
    MatIconModule,
    DynamicModule,
  ],
})
export class ExternalTypeModule {}
